// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/coge/piano-conti?societaId=',
    requestBody: null,
    response: '{ success: true, data: [tree] }'
  },
  {
    method: 'GET',
    endpoint: '/api/registri-contabili?societaId=',
    requestBody: null,
    response: '{ success: true, data: [...] }'
  },
  {
    method: 'GET',
    endpoint: '/api/causali-contabili?societaId=',
    requestBody: null,
    response: '{ success: true, data: [...] }'
  },
  {
    method: 'GET',
    endpoint: '/api/sezionali-iva?societaId=',
    requestBody: null,
    response: '{ success: true, data: [...] }'
  },
  {
    method: 'GET',
    endpoint: '/api/codici-iva?societaId=',
    requestBody: null,
    response: '[{ id, codice, descrizione, aliquota, attivo }]'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?societaId=',
    requestBody: null,
    response: '[{ id, codice, ragioneSociale, nome, cognome }]'
  },
  {
    method: 'GET',
    endpoint: '/api/conti-analitici?societaId=',
    requestBody: null,
    response: '{ success: true, data: [tree con figli] }'
  },
  {
    method: 'GET',
    endpoint: '/api/scritture-contabili/:id',
    requestBody: null,
    response: '{ success: true, data: { ..., righe: [...] }, logs: [...] }'
  },
  {
    method: 'POST',
    endpoint: '/api/scritture-contabili/applica-causale',
    requestBody: '{ causaleId, societaId }',
    response: '{ success: true, data: { causale, sezionaleIvaDefault, registroContabileDefault, righe: [...] } }'
  },
  {
    method: 'POST',
    endpoint: '/api/scritture-contabili',
    requestBody: '{ societaId, registroContabileId, data, causaleId, sezionaleIvaId, nominativoId, numeroDocumento, dataDocumento, descrizione, note, righe }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/scritture-contabili/:id',
    requestBody: '{ ...stesso payload (registroContabileId immutabile in PUT)... }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/scritture-contabili/:id/conferma',
    requestBody: null,
    response: '{ success: true, data: { id, numero, anno, numeroSezIva, annoSezIva } }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/scritture-contabili/:id/storna',
    requestBody: '{ data }',
    response: '{ success: true, data: { id, numero, anno } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
